// removed by extract-text-webpack-plugin
module.exports = {"viewToggle":"_3waobOwyXbWUDrnTWdyNKw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/components/PlaylistsToggleViewButton/PlaylistsToggleViewButton.scss
// module id = 1365
// module chunks = 1